/* eslint-disable */
export default {
  ringing: 'Eingehender Anruf',
  callConnected: 'Anruf verbunden',
} as const;

// @key: @#@"ringing"@#@ @source: @#@"Incoming call"@#@
// @key: @#@"callConnected"@#@ @source: @#@"Call connected"@#@
